import {Dropdown} from '@/components-v2/molecules/Dropdown/Dropdown'
import {SegmentModal} from '@/features/Segments'
import {SegmentTypes} from '@/utils/constants/promotionConstants'
import {useMemo, useState} from 'react'

/**
 * @typedef {Object} SegmentDropdownProps
 * @property {string[]} [value] Selected segment ids.
 * @property {(value: string[]) => void} [onChange] Callback triggered with updated selected segment ids.
 */

/**
 * @param {SegmentDropdownProps} props
 */
export const SegmentDropdown = ({value = [], onChange = () => {}}) => {
  const [showSegmentModal, setShowSegmentModal] = useState(false)

  const handleSubmit = values => {
    const updatedValues = values.map(segment => segment.segmentId)
    onChange(updatedValues)
  }

  const handleClose = () => {
    setShowSegmentModal(false)
  }

  const existingSelections = useMemo(() => {
    const segments = value || []
    return segments.map(segmentId => ({
      segmentId: segmentId,
      segmentGroupId: '',
      segmentName: segmentId,
    }))
    // Names are only a placeholder here (the closed dropdown itself never shows names either,
    // only raw ids). Once the user opens the modal and interacts with an item, real segment data
    // (including its name) comes from SegmentModalListContent's own lightweight paginated fetch,
    // replacing this placeholder entry. Keying on the joined ids (not `value`'s reference) keeps
    // this memo stable across unrelated re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(value || []).join('|')])

  const dropdownValue = value.map(segment => ({id: segment, displayText: segment}))

  const placeholderText = value?.length > 0 ? value?.join(', ') : 'Select segments'

  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setShowSegmentModal(true)}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setShowSegmentModal(true)
          }
        }}
        style={{cursor: 'pointer'}}
      >
        <Dropdown
          className="text-sm"
          childList={[]}
          selectedValue={dropdownValue}
          isJsonWrap={false}
          selection={'multiple'}
          placeholder={placeholderText || ''}
          updateValue={() => {}}
          style={{pointerEvents: 'none', width: 'auto'}}
        />
      </div>
      <SegmentModal
        show={showSegmentModal}
        type={SegmentTypes.SEGMENT_LIST}
        onClose={handleClose}
        onSubmit={handleSubmit}
        existingSelections={existingSelections}
      />
    </div>
  )
}
